import Fireworks from "@/components/eastereggs/Fireworks.vue";
import Snow from "@/components/eastereggs/Snow.vue";
import Loader from "@/components/Loader.vue";
import MobileMenu from "@/components/MobileMenu.vue";
import Toast from "@/components/Toast.vue";
import * as Sentry from "@sentry/browser";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import moment from "moment";
import Vue from "vue";
import authentication from "./store/authentication";
// @ts-ignore
import { AuthenticationContext } from "vue-adal";
import { SidebarMenu } from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import User from "./types/User/User";
Vue.component("Loader", Loader);
Vue.component("authentication", authentication);
Vue.component("SidebarMenu", SidebarMenu);
Vue.component("Toast", Toast);
Vue.component("Snow", Snow);
Vue.component("Fireworks", Fireworks);
//@ts-ignore
Vue.use(SidebarMenu);
Vue.use(BootstrapVue);
Vue.component("MobileMenu", MobileMenu);
export default Vue.extend({
    data() {
        return {
            enableEffectsValue: false,
            version: "2.0",
            userRoles: [],
            selectedRole: "",
            drawer: true,
            isStakeholder: false,
            loggedInUserName: "Joel",
            userImpersonationActive: false,
            impersonatedUser: null,
            userPreLoaded: false,
            showLogout: false,
            adminPreLoaded: false,
            menuHidden: false,
            menuCollapsed: true,
            customStyle: "",
            loggedInUser: "",
            doneLoading: false,
            totalTime: 0,
            hideAdmin: false,
            specialBackground: false,
            //hiding buttons based on permissions
            menu: {
                myData: false,
                addTime: false,
                levelData: false,
                teamManagerMyTeam: false,
                monthlySummary: false,
                monthlyCalendar: false,
                vacationPlanner: false,
                //stakeholder
                stakeholderHours: false,
                //admin
                adminGroup: false,
                adminUserHours: false,
                adminCustomerHours: false,
                adminUserSettings: false,
                adminManageTariffs: false,
                adminSalary: false,
                adminTeamSettings: false,
                adminLevels: false,
                adminConsultantLevels: false,
                //finanace
                financeGroup: false,
                financeSalesOrders: false,
                financeStackOrders: false,
                financeSalary: false,
            },
            showMenu: false,
            expandEmployeeMenu: false, //value that determines if the employee group should be expanded
        };
    },
    computed: {
        pageBackground() {
            return this.$vuetify.theme.currentTheme.pageBackground;
        },
        isDarkMode() {
            return this.$vuetify.theme.dark;
        },
        isDev() {
            return process.env.VUE_APP_SENTRY_ENV !== "production";
        },
        isAuthenticated() {
            return authentication.isAuthenticated();
        },
        isCustomBackground() {
            const bgs = ["stpatric", "sweden", "halloween", "xmas", "newyears"];
            let customValueSet = false;
            if (this.$store.getters.getSelectedDate !== undefined &&
                this.$router.currentRoute.name === "Home" &&
                this.$data.enableEffectsValue === true) {
                let backgroundClass = null;
                const weekNumber = window.dateHandler.getWeekNumber(this.$store.getters.getSelectedDate);
                if (window.dateHandler.currentWeekContainsDate(this.$store.getters.getSelectedDate, moment().format("YYYY-03-17"))) {
                    backgroundClass = "stpatric";
                    customValueSet = true;
                }
                else if (window.dateHandler.currentWeekContainsDate(this.$store.getters.getSelectedDate, moment().format("YYYY-06-06"))) {
                    backgroundClass = "sweden";
                    customValueSet = true;
                }
                else if (window.dateHandler.currentWeekContainsDate(this.$store.getters.getSelectedDate, moment().format("YYYY-10-31"))) {
                    backgroundClass = "halloween";
                    customValueSet = true;
                }
                else if (window.dateHandler.currentWeekContainsDate(this.$store.getters.getSelectedDate, moment().format("YYYY-12-24"))) {
                    backgroundClass = "xmas";
                    customValueSet = true;
                }
                else if (window.dateHandler.isLastWeekOfYear(this.$store.getters.getSelectedDate)) {
                    backgroundClass = "newyears";
                    customValueSet = true;
                }
                const body = document.querySelector("#timeNow");
                if (body) {
                    bgs.forEach((bg) => body.classList.remove(bg)); // remove custom bg classes but keep the needed ones
                    if (backgroundClass !== null) {
                        body.classList.add(backgroundClass);
                    }
                }
                console.log("backgroundclass", backgroundClass);
            }
            else {
                const body = document.querySelector("#timeNow");
                if (body) {
                    bgs.forEach((bg) => body.classList.remove(bg)); // remove custom bg classes but keep the needed ones
                }
            }
            return customValueSet;
        },
        isWinter() {
            if (this.$store.getters.getSelectedDate !== undefined &&
                this.$router.currentRoute.name === "Home" &&
                this.$data.enableEffectsValue === true) {
                return (window.dateHandler.getMonthNumber(this.$store.getters.getSelectedDate) === 12);
            }
        },
        isParty() {
            if (this.$store.getters.getSelectedDate !== undefined &&
                this.$router.currentRoute.name === "Home") {
                return window.dateHandler.isLastWeekOfYear(this.$store.getters.getSelectedDate);
            }
        },
    },
    methods: {
        toggleDarkMode(val) {
            this.$vuetify.theme.dark = val;
            localStorage.darkMode = val;
        },
        addMenuItems() { },
        enableEffectsToggle() {
            localStorage.enableEffectsValue = this.$data.enableEffectsValue;
        },
        stopImpersonation() {
            this.$data.userImpersonationActive = false;
            this.$store.commit("setUserImpersonation", null);
            this.$store.dispatch("getMyTariffs");
            this.$store
                .dispatch("validateEmployeeAsync")
                .then((response) => {
                const employeeReturn = response.data;
                this.$store.commit("setLoggedInUser", employeeReturn);
                //this.$store.commit('setTariffs', employeeReturn.tariffs);
            })
                .catch((error) => {
                console.log(error);
            })
                .then(() => {
                this.loadAdminData();
                //this.selectRole("admin", true); //set to admin when ending impersonation (they are the only ones that can impersonate)
                this.$router
                    .push({ name: "AdminUserSettings" })
                    .catch((err) => { });
            });
        },
        logOut() {
            this.$store.dispatch("signOut");
        },
        async getUserDataAsync() {
            //await this.$store.dispatch('ValidateUser').then(()=>{
            const user = this.$store.getters.getTokenProfile;
            console.log("loggedinuser", user);
            Sentry.setUser({ id: user.unique_name, roles: user.roles }); // Set sentry user for trackability
            this.$data.loggedInUserName = user.name;
            console.log(user);
            if (user.roles === undefined) {
                this.$store.dispatch("ToastMessage", {
                    type: "error",
                    message: user.unique_name +
                        " does not have permission to access this site. Are you using the correct account?",
                });
                this.$data.showLogout = true;
            }
            else {
                if (user.roles.indexOf("Consultant") !== -1) {
                    this.loadConsultantData();
                }
                if (user.roles.indexOf("Employee") !== -1) {
                    this.loadEmployeeData();
                }
                if (user.roles.indexOf("Stakeholder") !== -1) {
                    this.loadStakeholderData();
                    //if you are only a stakeholder
                    if (user.roles.length === 1) {
                        this.$data.userPreLoaded = true;
                        console.log("sets preloaded here");
                        this.$router
                            .push({ path: "/stakeholder/hours" })
                            .catch((err) => { });
                    }
                }
                if (user.roles.indexOf("TeamManager") !== -1 ||
                    user.roles.indexOf("Director") !== -1) {
                    this.loeadTeamManagerData();
                    //hack to allow team managers to see admin settings
                    if (this.$data.userRoles
                        .map((e) => {
                        return e.text;
                    })
                        .indexOf("Admin") === -1) {
                        this.$data.userRoles.push({ text: "Admin", value: "admin" });
                    }
                }
            }
            if (user.roles.indexOf("Admin") !== -1 ||
                user.roles.indexOf("Employee") !== -1 ||
                user.roles.indexOf("Consultant") !== -1) {
                const waitForAdminData = user.roles.indexOf("Admin") !== -1;
                this.loadSharedData(waitForAdminData);
            }
            if (user.roles.indexOf("Admin") !== -1 ||
                user.roles.indexOf("Director") !== -1 ||
                user.roles.indexOf("TeamManager") !== -1) {
                this.loadAdminData();
            }
            if (user.roles.indexOf()) {
                //console.log("roles",user.roles)
            }
            //render the menu when all items have been loaded
            this.$data.showMenu = true;
            //});
        },
        loadSharedData(waitForAdminData) {
            const currentYear = moment(new Date()).format("YYYY");
            //flytta denna
            Promise.all([
                this.$store.dispatch("getCurrentUser"),
                this.$store.dispatch("loadGlobalTariffsAsync"),
                this.$store.dispatch("getMyTariffs"),
                this.$store.dispatch("getClosedReportsDate")
            ])
                .then((values) => {
                const userReturn = values[0].data;
                userReturn.closedReportsDate = values[3].data;
                this.$store.commit("setGlobalTariffs", values[1].data);
                this.$store.commit("setLoggedInUser", userReturn);
                if (!waitForAdminData) {
                    //do not send loading event if admin data has to load
                    this.$data.userPreLoaded = true;
                }
            })
                .catch((err) => {
                window.errorHandler.logError(err, "App.vue - loadSharedData");
            });
        },
        loadEmployeeData() {
            //this.$data.userPreLoaded = false;
            //this.loadSharedData();
            //set navigation
            this.$data.menu.myData = true;
            this.$data.menu.addTime = true;
            this.$data.menu.levelData = true;
            this.$data.menu.monthlySummary = true;
            this.$data.menu.monthlyCalendar = true;
            this.$data.menu.vacationPlanner = true;
        },
        loadStakeholderData() {
            this.$data.menu.stakeholderHours = true;
        },
        loadConsultantData() {
            this.$data.menu.myData = true;
            this.$data.menu.addTime = true;
            this.$data.menu.monthlySummary = true;
            this.$data.menu.monthlyCalendar = true;
            this.$data.menu.vacationPlanner = true;
        },
        loeadTeamManagerData() {
            //set navigation
            // this.$data.menu.teamManagerMyTeam = true;
        },
        loadAdminData() {
            //this.loadSharedData();
            this.$store
                .dispatch("adminLoadEmployees")
                .then((result) => {
                this.$store.commit("setGlobalEmployeesAdmin", result.data);
                // team manager and up only
                this.$data.menu.adminUserHours = true;
                this.$data.menu.adminCustomerHours = true;
                this.$data.menu.adminUserSettings = true;
                this.$data.menu.adminManageTariffs = true;
                this.$data.menu.adminSalary = true;
                this.$data.menu.adminTeamSettings = true;
                this.$data.menu.adminLevels = true;
                this.$data.menu.adminConsultantLevels = true;
                this.$data.menu.adminGroup = true;
                this.$data.userPreLoaded = true;
                //finanace menu
                this.$data.menu.financeGroup = true;
                this.$data.menu.financeSalary = true;
                // director and up only
                if (AuthenticationContext.checkRoles(["Admin", "Director"])) {
                    this.$data.menu.financeSalesOrders = true;
                    this.$data.menu.financeStackOrders = true;
                }
                // admin only
                if (AuthenticationContext.checkRoles(["Admin"])) {
                }
            })
                .catch((err) => {
                window.errorHandler.logError(err, "App.vue - loadAdminData");
            });
        },
        selectRole(roleName, userHasRole) {
            //we load the specific data based on what role the user has
            this.$data.selectedRole = roleName.toLowerCase();
            if (roleName.toLowerCase() === "employee") {
                //this.loadEmployeeData(userHasRole);
            }
            else if (roleName.toLowerCase() === "admin") {
                //this.loadAdminData(userHasRole);
            }
            else if (roleName.toLowerCase() === "stakeholder") {
                this.$router
                    .push({ path: "/stakeholder/hours" })
                    .catch((err) => { });
            }
        },
    },
    beforeMount() {
        // validating the user login by calling the function in the store
        this.getUserDataAsync();
        // change html colour
        const html = document.querySelector("html");
        if (html) {
            html.style.backgroundColor = this.$vuetify.theme.dark
                ? "#272727"
                : "#f4f8f9";
        }
    },
    watch: {
        pageBackground() {
            const html = document.querySelector("html");
            if (html) {
                html.style.backgroundColor = this.$vuetify.theme.dark
                    ? "#272727"
                    : "#f4f8f9";
            }
        },
    },
    created() {
        //checks if a user is being impersonated
        if (this.$route.query.impersonate !== undefined) {
            this.$store
                .dispatch("getAllUsers")
                .then((result) => {
                const user = result.data.filter((obj) => {
                    return obj.id === this.$route.query.impersonate;
                });
                if (user !== undefined && user.length > 0) {
                    const impersonateUser = new User(user[0]); //set the user object as impersonated user
                    this.$store.dispatch("impersonateUser", impersonateUser);
                    this.$data.userImpersonationActive = true;
                    this.$router.push({
                        query: { impersonate: this.$route.query.impersonate },
                    });
                }
            })
                .catch((err) => {
                window.errorHandler.logError(err, "App -> mounted() -> impersonate user");
            });
        }
        window.eventBus.$on("userImpersonationUpdated", () => {
            this.$data.impersonatedUser = this.$store.getters.getImpersonatedUser;
            if (this.$data.impersonatedUser !== null) {
                this.$data.userImpersonationActive = true;
            }
            else {
                this.$data.userImpersonationActive = false;
            }
        });
        window.eventBus.$on("toggleMobileMenu", () => {
            if (this.$data.menuCollapsed === false) {
                this.$data.menuCollapsed = true;
                this.$data.menuHidden = true;
            }
            else {
                this.$data.menuCollapsed = false;
                this.$data.menuHidden = false;
            }
        });
    },
    mounted() {
        //enables or disables effects for the user.
        if (localStorage.enableEffectsValue) {
            let value = false;
            if (localStorage.enableEffectsValue === "true") {
                value = true;
            }
            this.$data.enableEffectsValue = value;
        }
    },
});
